import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row mb-3" }
const _hoisted_2 = { class: "col-12 col-sm-4" }
const _hoisted_3 = { class: "d-flex body-strong text-grey-900 text-start mb-2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "body text-start text-grey-700 mb-2 mb-md-0" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "d-flex flex-column col-12 col-sm-8 body text-grey-900 text-start" }
const _hoisted_10 = { class: "me-1" }
const _hoisted_11 = {
  height: 16,
  width: 16,
  class: "icon"
}
const _hoisted_12 = ["xlink:href"]
const _hoisted_13 = { class: "me-1" }
const _hoisted_14 = {
  key: 0,
  class: "ms-1"
}

import { computed, watch, ref, onMounted } from "vue";
import ParticipantsTotals from "@/vue/planning/components/common/participantsTotals.vue";
import packOptionConfig from "@/config/packOptionsConfig.js";
import { useStore } from "@/vue/planning/store/store";
import type { Variant } from "@/types/index";
import { isOriginHub } from "@/vue/planning/logic/isOriginHub";
import { airportCodeMap } from "@/config/airportCodeMap";
import flightPackCode from "@/config/flightPackCode";

// Props
interface Props {
	variant?: Variant;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'options',
  props: {
    variant: { default: () => ({} as Variant) }
  },
  setup(__props: any) {

const props = __props;

// Store
const store = useStore();

// Ref
const proposedOriginByWiyp = ref<string | null>(null);

// Computed
const packCode = computed<string>(() => store.state.packCode);
const currentPackCode = computed<string>(() => store.state.currentPackCode);
const content = computed<Record<string, string>>(() => store.state.content);
const participants = computed<number[]>(() => store.state.participants);
const locale = computed<string>(() => store.getters.locale);
const flightOrigin = computed<string | null>(() => store.state.flightOrigin);

const currentPackConfig = computed<string[]>(() => {
	const config = packOptionConfig as Record<string, string[]>;
	if (props.variant?.codePackage && config[props.variant.codePackage]) {
		return config[props.variant.codePackage];
	}
	return config[packCode.value] || [];
});

const originAirport = computed<string | null>(() => {
	// Recompute when flightOrigin or proposedOriginByWiyp changes
	const originToUse = proposedOriginByWiyp.value || flightOrigin.value;
	const airportName = airportCodeMap.get(originToUse || "");
	if (airportName && airportName.name) {
		return `${content.value['planningSummary_options_from']} ${airportName.name}`;
	}
	return null;
});
// Watch for when variant and store state become available
watch(
	() => [props.variant, currentPackCode.value, flightOrigin.value, store.state.wiypDefaultFlightOrigin] as const,
	([variant, currentPackCodeValue, flightOriginValue, defaultFlightOriginValue]) => {
		// Only proceed if we have the necessary data
		if (!variant?.codePackage || !currentPackCodeValue || (!defaultFlightOriginValue && !flightOriginValue)) {
			return;
		}
		proposedOriginByWiyp.value = null;
		if (flightPackCode.includes(currentPackCodeValue) && isOriginHub(flightOriginValue, airportCodeMap)) {
			const participants = store.state.participants.join('-');
			// If defaultFlightOriginValue is set and arrived, use it, otherwise use flightOriginValue
			const wiypCall = 
					store.getters.getWiypCallByFamilyCompositionAndOriginAndPackageCodeAndId(participants,defaultFlightOriginValue,variant.codePackage,variant.prestId)
				?? 	store.getters.getWiypCallByFamilyCompositionAndOriginAndPackageCodeAndId(participants,flightOriginValue,variant.codePackage,variant.prestId);
			
			if (wiypCall?.flightOrigin) {
				proposedOriginByWiyp.value = wiypCall.flightOrigin;
			}			
		}
	},
	{ immediate: true } // Run immediately to check initial values
);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (currentPackConfig.value.length > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(content.value.planningSummary_options_optionTitle), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(content.value.planner_resumeNoOptions), 1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (currentPackConfig.value.length > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
              (proposedOriginByWiyp.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(content.value.planningSummary_options_optionSubtitle_flight), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(content.value.planningSummary_options_optionSubtitle), 1)
                  ], 64))
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(content.value.planner_resumeAddOption), 1))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentPackConfig.value, (optionName, option_i) => {
        return (_openBlock(), _createElementBlock("span", {
          class: "my-1 my-md-0 d-flex flex-row flex-nowrap align-items-center",
          key: option_i
        }, [
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(), _createElementBlock("svg", _hoisted_11, [
              _createElementVNode("use", {
                "xlink:href": `#___icon___${optionName}`
              }, null, 8, _hoisted_12)
            ]))
          ]),
          _createElementVNode("span", _hoisted_13, _toDisplayString(content.value[`planningSummary_options_${optionName}`]), 1),
          _createElementVNode("span", null, [
            _createVNode(ParticipantsTotals, {
              participants: participants.value,
              content: content.value,
              optionName: optionName,
              variant: _ctx.variant,
              displayWithIcons: true,
              excludedAges: [1]
            }, null, 8, ["participants", "content", "optionName", "variant"])
          ]),
          (optionName==='flight' && proposedOriginByWiyp.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(originAirport.value), 1))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}
}

})